import Navbar from "../components/Navbar";
import GalleryImageList from "../components/GalleryImageList";
//import DataSection from "../components/DataSection";
const Gallery = () => {
  return (
    <div className="App">
      <Navbar />
      <GalleryImageList />
    </div>
  );
};

export default Gallery;
